export const getBaseUrl = () => process.env.REACT_APP_API_URL || 'https://apitienda.zapateriaselene.com';

export async function fetchStates() {
  const res = await fetch(`${getBaseUrl()}/api/catalog/states`);
  if (!res.ok) throw new Error('No se pudieron cargar los estados');
  return res.json();
}

export async function fetchMunicipalities(stateId) {
  const res = await fetch(`${getBaseUrl()}/api/catalog/municipalities?state_id=${stateId}`);
  if (!res.ok) throw new Error('No se pudieron cargar los municipios');
  return res.json();
}

export async function fetchPostalCodeInfo(cp) {
  const baseUrl = getBaseUrl();
  const res = await fetch(`${baseUrl}/api/catalog/postal-code/${cp}`);
  if (!res.ok) throw new Error('CP no encontrado');
  return res.json(); // { state_id, municipality_id, settlements: [...] }
}